import React from 'react';
import { ShoppingIntroDialog } from '../../shop/components/shop-intro-dialog';

interface ISeeInPersonDialogProps {
  showDialog: boolean;
  onDismiss: () => void;
}

export const SeeInPersonDialog: React.FunctionComponent<ISeeInPersonDialogProps> = (props) => {

  return (
    <ShoppingIntroDialog
      showDialog={props.showDialog}
      title={'Where to see this door'}
      richContent={<>
      <p>
        Like Amazon, we are an exclusively online retailer.  As such, we do not have a showroom.  But you know someone who does!  We sell Larson storm doors &ndash; just like the Lowe&#39;s store nearest you (we are not affiliated with Lowe&#39;s).
      </p>
      <h3>Aren&#39;t you worried about losing my business if I go there?</h3>
      <p>
        <strong>Nope!</strong>  We are a company built for people want a new door <em>and</em> expert installation.  Our prices always include both; theirs do not.  If you want to know their cost of installation, <strong>you have to pay $30 - $40 to find out... the very thing we&#39;re telling you, upfront, for free</strong>.  So yeah, head on over there and check out this door :)
      </p>
      </>}
      onClose={props.onDismiss}
      dismissButtonText={'Got it'}
    />
  );
};
